export enum RolesEnum {
  SUPER_ADMIN = "superAdmin",
  ADMIN = "admin",
  USER = "user",
  SEO = "seo",
  CONTENT = "content",
  FINANCE = "finance",
}
